import {Box, Flex, FormLabel} from '@chakra-ui/react';
import React, {useState} from 'react';
import Select from 'react-select';
import {useClient} from '../../views/Maintenance/ClientMaintenance';

export default function ClientLocationSelect({
  selectedLocationId,
  setSelectedLocationId,
}: {
  selectedLocationId: string | null;
  setSelectedLocationId: (id: string | null) => void;
}) {
  const {client} = useClient();

  const locations =
    client?.locations?.map(({id, loId, loName, loRptname}) => ({
      value: id,
      label: loId + ' | ' + loName + ' | ' + loRptname,
    })) ?? [];

  const selectedLocation = locations.find(location => location.value === selectedLocationId) ?? null;

  return (
    <Box mr="auto" alignItems="center">
      <FormLabel fontSize="sm" mb="-0.5" ml="1">
        Select Location
      </FormLabel>
      <Box>
        <Select value={selectedLocation} onChange={val => setSelectedLocationId(val.value)} options={locations} />
      </Box>
    </Box>
  );
}
